import { useCallback } from 'react';

import { useQueryClient } from '@tanstack/react-query';
import { useSetAtom } from 'jotai';

import { useShopPageQueryOptions } from 'src/hooks/useShopQuery';
import { showPaymentPopupAtom } from 'src/stores/shop/atoms';
import { PaymentPopupInfo } from 'src/types/Payments';

const useShowPayment = () => {
  const showPaymentPopup = useSetAtom(showPaymentPopupAtom);
  const queryClient = useQueryClient();
  const shopPageQueryOptions = useShopPageQueryOptions();

  return useCallback(
    async (paymentPopupInfo: PaymentPopupInfo) => {
      const shopData = await queryClient.ensureQueryData(shopPageQueryOptions);
      showPaymentPopup({
        paymentPopupInfo,
        pgPaymentMethod: shopData.pgPaymentMethod,
      });
    },
    [queryClient, showPaymentPopup, shopPageQueryOptions]
  );
};

export default useShowPayment;
